import { Reading } from "./Reading";

export class ThermReading
{
    ThermID: number = 0;
    Description: string = "";
    Readings: Reading[] = [];
    Strength: number = 0;
}